import Rellax from 'rellax';

/** Selector for any instance of this _Friendation_ component */
const selector = '[is="block-cta-dynamic"]';

/**
 * Friendation component
 */
export const blockCtaDynamic = () => {
  /** Instances of this Friendation component */
  const components: HTMLElement[] = Array.from(
    document.querySelectorAll(selector)
  );

  // Skip parallax entirely if the user prefers reduced motion
  const prefersReducedMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;

  components.forEach((component) => {
    const textEl = component.querySelector<HTMLElement>('.text');
    if (!textEl || prefersReducedMotion) return;

    // Responsive speeds via data attributes (read by Rellax per breakpoint zone):
    //   xs  0–575px   → speed 1
    //   mobile  576–767px → speed 1
    //   tablet  768–1279px → speed 1
    //   desktop  1280px+   → speed 2
    textEl.dataset.rellaxXsSpeed = '1';
    textEl.dataset.rellaxMobileSpeed = '1';
    textEl.dataset.rellaxTabletSpeed = '1';
    textEl.dataset.rellaxDesktopSpeed = '2';

    // Positive speed: element moves UP when scrolling DOWN (against scroll direction).
    // center: true → zero offset when component center aligns with viewport center.
    new Rellax(textEl, {
      breakpoints: [576, 768, 1280],
      center: true,
      round: true,
      vertical: true,
      horizontal: false
    });
  });
};
